export const hover = '#008C45';
export const darkGreen = '#006B00';
export const lightGreen = '#3D9E71';
export const font = 'Poppins';


